import { createSlice } from '@reduxjs/toolkit';
import { emptyFormState } from '../emptyState';
import { postStatus } from '../status';
import { postCreateDcdkApp } from 'api';

// Then, handle actions in your reducers:
const createDcdkAppSlice = createSlice({
  name: 'createDcdkApp',
  emptyFormState,
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
    createDcdkAppPostStart: (state) => {
      state.status = postStatus.POST_START;
      state.fetching = true;
      state.error = false;
    },
    createDcdkAppPostSuccess: (state, { payload }) => {
      state.status = postStatus.POST_SUCCESS;
      state.payload = payload;
      state.fetching = false;
      state.error = false;
    },
    createDcdkAppPostFail: (state, { payload }) => {
      state.status = postStatus.POST_FAIL;
      state.payload = payload;
      state.fetching = false;
      state.error = true;
    },
    createDcdkAppPostReset: (state) => {
      state.status = null;
      state.payload = null;
      state.fetching = false;
      state.error = false;
    },
  },
});

// actions generated from the slice, TODO: remove start,success,fail
export const {
  createDcdkAppPostStart,
  createDcdkAppPostSuccess,
  createDcdkAppPostFail,
  createDcdkAppPostReset,
} = createDcdkAppSlice.actions;

// The reducer
export const createDcdkAppReducer = createDcdkAppSlice.reducer;

// Asynchronous thunk action
export const createDcdkAppPost = (formData) => (dispatch) => {
  dispatch(createDcdkAppPostStart());

  postCreateDcdkApp(formData)
    .then((payload) => {
      dispatch(createDcdkAppPostSuccess(payload));
    })
    .catch((error) => {
      dispatch(createDcdkAppPostFail(error));
    });
};
